import React, { useEffect, useState } from "react";
import "./VendorProductsDetailComponent.css";
import {
  Apiurl,
  Encryption,
  GetLocalStorageParsed,
  parseData,
  secretKey,
  stringifyData,
} from "../../Pages/utils/page";
import axios from "axios";
import moment from "moment";
import ProductCountdown from "../Countdown/Countdown";
import { Carousel } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";

const VendorProductsDetailComponent = ({ setLoading }) => {
  const FetchToken = GetLocalStorageParsed("AuthToken");

  const router = useNavigate();
  const [urlId, setUrlId] = useState(null);

  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [vendorName, setVendorName] = useState();

  const [vendorProducts, setVendorProducts] = useState();
  console.log(vendorProducts, "vendorProducts");
  const [bannersData, setBannersData] = useState();
  const [totalResult, setTotalResult] = useState();
  const [otherVendorProducts, setOtherVendorProducts] = useState();
  console.log(otherVendorProducts,"otherVendorProducts")
  const [currentPage, setCurrentPage] = useState(1); // Current page state
  const pageSize = 12; // Page size
  const totalPages = Math.ceil(totalResult / pageSize); // Calculate total pages

  const getTopVendorProductsById = () => {
    setLoading("vendor");
    // const urlId = decodeURIComponent(window.location.pathname?.split("/")?.[2]); // Decode URL
    const urlId = decodeURIComponent(window.location.hash?.split("/")?.[2]); // Decode URL
    const bytes = CryptoJS.AES.decrypt(urlId, secretKey());
    const originalId = bytes.toString(CryptoJS.enc.Utf8);
    const data = {
      id: originalId,
    };
    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Product/FetchAllBannersByVendorId`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setBannersData(data?.AllBanners);
        setLoading("");

        // const filterBanner = banners?.filter((product) => {

        //     return product.IsPublish === true
        // });
      })
      .catch((error) => {});
  };
  const FetchAllPaginatedProductsFromVendorId = (pageNumber) => {
    const urlId = decodeURIComponent(window.location.pathname?.split("/")?.[2]); // Decode URL
    // const urlId = decodeURIComponent(window.location.hash?.split("/")?.[2]); // Decode URL
    const bytes = CryptoJS.AES.decrypt(urlId, secretKey());
    const originalId = bytes.toString(CryptoJS.enc.Utf8);
    const data = {
      PageNumber: pageNumber, // Use the passed pageNumber
      PageSize: pageSize,
      Id: originalId,
    };
    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Product/FetchAllPaginatedProductsFromVendorId`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setTotalResult(e?.data?.totalRecords);
        setVendorProducts(data?.AllProducts);
      })
      .catch((error) => {});
  };
  const GetAllProductsOfEveryVendorExcludingCurrent = (pageNumber) => {
    const urlId = decodeURIComponent(window.location.pathname?.split("/")?.[2]); // Decode URL
    // const urlId = decodeURIComponent(window.location.hash?.split("/")?.[2]); // Decode URL
    const bytes = CryptoJS.AES.decrypt(urlId, secretKey());
    const originalId = bytes.toString(CryptoJS.enc.Utf8);
    const data = {
      PageNumber: pageNumber, // Use the passed pageNumber
      PageSize: pageSize,
      Id: originalId,
    };
    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Product/GetAllProductsOfEveryVendorExcludingCurrent`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setOtherVendorProducts(data);
      })
      .catch((error) => {});
  };
  const [categoriesData, setcategoriesData] = useState();

  const handleGetCategory = () => {
    const option = {
      method: "Get",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken}`,
      },
      url: `${Apiurl()}/api/Product/GetCategoriesFromProduct`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e.data.result);
        setcategoriesData(data);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    getTopVendorProductsById();
    FetchAllPaginatedProductsFromVendorId();
    GetAllProductsOfEveryVendorExcludingCurrent();
    handleGetCategory();
  }, []);
  useEffect(() => {
    FetchAllPaginatedProductsFromVendorId(currentPage); // Fetch products on page load
  }, [currentPage]);

  return (
    <>
      <div className="banner_section" style={{ flex: "1" }}>
        {/* <div className="background-bg-setion">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-lg-12 mb_commn_pd_0">
                      <div className="top-categories-section">
                        <div className="top-categories-align-center">
                          {categoriesData?.map((i) => {
                            return (
                           
                              <div
                                class="normal-cat text-center cate-spc-mx hover-effect"
                                onClick={() => {
                                  router(`/filter/${Encryption(i?.Id)}`);
                                }}
                              >
                                <img
                                  src={`/Images/${i?.Id}.jpg`}
                                  alt={i?.CatgeoryName}
                                  className="img-hover"
                                />
                                <p>{i?.CatgeoryName}</p>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
        <div>
          <div>
            {bannersData?.length ? (
              <>
                <Carousel className="banner_crousel_head" interval={null}>
                  {bannersData?.map((item) => {
                    const banner = item?.BannerUrl.split('"');
                    const bannerUrl = `${Apiurl()}/${banner?.[1]}`;

                    return (
                      <Carousel.Item
                        key={item.Id}
                        className="Bannner-Inner-container"
                      >
                        <img
                          className="Banner-image"
                          src={bannerUrl}
                          alt={item.BusinessName}
                          layout="intrinsic"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/Images/banner-default.jpg";
                          }}
                        />
                      </Carousel.Item>
                    );
                  })}
                </Carousel>
              </>
            ) : (
              <img
                src="https://shopsaverz.com/Image/Exclusive-Deals-from-Partner-Affiliates.jpg"
                className="w-100"
              />
            )}
          </div>
          <div className="background-bg-setion">
            <div className="container-fluid">
              <div className="top-ven_products_section">
                <div className="row">
                  <div className="col-lg-12 mb_commn_pd_0">
                    <h4 class="common_heading">
                      Flame Private Lmtd. Deals And Offers
                    </h4>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12 mb_commn_pd_0">
                    <div className="vendor-products-main-wraper">
                      <div className="row">
                        {vendorProducts?.length ? (
                          vendorProducts?.map((item) => {
                            const imagesArray = JSON.parse(item?.Images);

                            const defaultImage = imagesArray.find(
                              (img) => img.Default
                            );

                            const imageUrl = defaultImage
                              ? `${Apiurl()}/${defaultImage.Images}`
                              : "";
                            const now = moment(); // Current time
                            const timeTo = moment(item?.ToPublishDate);
                            const timeDifferenceInHours = timeTo.diff(
                              now,
                              "hours"
                            );

                            return (
                              <div class="col-lg-2 col-sm-4 col-6 vendor_related_pro_spc product_new_btm_spc">
                                <div class="pro_detail_wrapper_new_section text-center">
                                  <img
                                    src={imageUrl}
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        "/Images/no-product-img-700.jpg";
                                    }}
                                    onClick={() => {
                                      router(
                                        `/productdetail/${Encryption(item?.Id)}`
                                      );
                                    }}
                                  />
                                  <h2>{item?.ProductName} </h2>
                                  <h3 class="pro-till-date" b-bc148tklez="">Till:  {moment(item.ToPushlishDate).format(
                                      " MMM DD YYYY"
                                    )}</h3>
                               

                                  {item?.IsProductInOffer == true ? (
                                    <>
                                      <h5>₹{item?.Mrp}</h5>
                                    </>
                                  ) : (
                                    <>
                                      <h5>
                                        {" "}
                                        ₹ {item?.DealPrice}{" "}
                                        <span className="mrp-price">
                                          ₹{item?.Mrp}
                                        </span>
                                        <span className="flat-dicsount">
                                          {" "}
                                          50% off
                                        </span>
                                      </h5>
                                    </>
                                  )}

                                  {item?.IsProductOutOfStock === true ? (
                                    <input
                                      type="button"
                                      value="Out of Stock"
                                      className="common_btn_new out_stock_btn_01"
                                    />
                                  ) : (
                                    <input
                                      type="button"
                                      onClick={() => {
                                        router(
                                          `/productdetail/${Encryption(
                                            item?.Id
                                          )}`
                                        );
                                      }}
                                      value={
                                        item?.IsProductInOffer == true
                                          ? "Bid Now"
                                          : item?.IsProductInOffer == false
                                          ? "Buy Now"
                                          : item?.IsProductInOffer == null
                                          ? "Contact Us"
                                          : null
                                      }
                                      className={
                                        item?.IsProductInOffer == true
                                          ? "common_btn_new bid_now_btn_01"
                                          : item?.IsProductInOffer == false
                                          ? "common_btn_new"
                                          : item?.IsProductInOffer == null
                                          ? "common_btn_new"
                                          : null
                                      }
                                    />
                                  )}
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <p>No Result</p>
                        )}
                      </div>
                      {totalPages > 1 && (
                        <div className="row" b-bc148tklez="">
                          <div
                            className="col-lg-12 mb_commn_pd_0"
                            b-bc148tklez=""
                          >
                            <div
                              className="pagination product_related_pagination"
                              b-bc148tklez=""
                            >
                              {Array.from({ length: totalPages }).map(
                                (_, index) => (
                                  <a
                                    key={index}
                                    className={
                                      currentPage === index + 1 ? "active" : ""
                                    }
                                    onClick={() => setCurrentPage(index + 1)}
                                  >
                                    {index + 1}
                                  </a>
                                )
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {otherVendorProducts?.length &&(
  <div className="background-bg-setion">
  <div className="container-fluid">
    <div className="other-merhant-main-section">
      <div className="row">
        <div className="col-lg-12 mb_commn_pd_0">
          <h4 class="common_heading">
          Other Merchant Products

          </h4>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 mb_commn_pd_0">
          <div className="vendor-products-main-wraper">
            <div className="row">
              {otherVendorProducts?.length ? (
                otherVendorProducts?.map((item) => {
                  const imagesArray = JSON.parse(item?.Images);

                  const defaultImage = imagesArray.find(
                    (img) => img.Default
                  );

                  const imageUrl = defaultImage
                    ? `${Apiurl()}/${defaultImage.Images}`
                    : "";
                  const now = moment(); // Current time
                  const timeTo = moment(item?.ToPublishDate);
                  const timeDifferenceInHours = timeTo.diff(
                    now,
                    "hours"
                  );

                  return (
                    <div class="col-lg-2 col-sm-3 col-6 product_new_btm_spc">
                      <div class="pro_detail_wrapper_new_section text-center">
                        <img
                          src={imageUrl}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src =
                              "/Images/no-product-img-700.jpg";
                          }}
                          onClick={() => {
                            router(
                              `/productdetail/${Encryption(item?.Id)}`
                            );
                          }}
                        />
                        <h2>{item?.ProductName} </h2>
                        <h3>
                          {moment(item.ProductToPublishDate).format(
                            "DD MMM YYYY, hh:mm A"
                          )}
                        </h3>

                        {item?.IsProductInOffer == true ? (
                          <>
                            <h5>₹{item?.Mrp}</h5>
                          </>
                        ) : (
                          <>
                            <h5>
                              {" "}
                              ₹ {item?.DealPrice}{" "}
                              <span className="mrp-price">
                                ₹{item?.Mrp}
                              </span>
                              <span className="flat-dicsount">
                                {" "}
                                50% off
                              </span>
                            </h5>
                          </>
                        )}

                        {item?.IsProductOutOfStock === true ? (
                          <input
                            type="button"
                            value="Out of Stock"
                            className="common_btn_new out_stock_btn_01"
                          />
                        ) : (
                          <input
                            type="button"
                            onClick={() => {
                              router(
                                `/productdetail/${Encryption(
                                  item?.Id
                                )}`
                              );
                            }}
                            value={
                              item?.IsProductInOffer == true
                                ? "Bid Now"
                                : item?.IsProductInOffer == false
                                ? "Buy Now"
                                : item?.IsProductInOffer == null
                                ? "Contact Us"
                                : null
                            }
                            className={
                              item?.IsProductInOffer == true
                                ? "common_btn_new bid_now_btn_01"
                                : item?.IsProductInOffer == false
                                ? "common_btn_new"
                                : item?.IsProductInOffer == null
                                ? "common_btn_new"
                                : null
                            }
                          />
                        )}
                      </div>
                    </div>

                  );
                })
              ) : (
                <p>No Result</p>
              )}
            </div>
           
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
          )}
        
          {/* <div className="container">
            <div className="top-ven_products_section">
              <div className="row">
                <div className="common_shadow_01">
                  <div className="col-lg-12">
                    <div className="row product_new_btm_spc_web">
                      <h4 className="common_heading mb_commn_pd_0">
                        {vendorName?.BusinessName}
                      </h4>
                      {vendorProducts?.map((item) => {
                        const image = item?.Images?.split('"');
                        const imageURL = `${Apiurl()}/${image?.[3]}`;
                        const now = moment(); // Current time
                        const timeTo = moment(item?.ToPushlishDate);
                        const timeDifferenceInHours = timeTo.diff(now, "hours");
                        return (
                          <div className="col-lg-3 col-sm-4 col-6 vendor_related_pro_spc product_new_btm_spc blur-effect">
                            <div className="pro_detail_wrapper_new">
                              <div className="pro_dtl_main_spc_wrapper">
                                <div className="pro_dtl_img_all_spc_wrapper">
                                  <img
                                    src={imageURL}
                                    alt="No Image"
                                    onClick={() => {
                                      router(
                                        `/productdetail/${Encryption(item?.Id)}`
                                      );
                                    }}
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        "/Images/no-product-img-700.jpg";
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="pro_desc_spacing-new">
                                <div className="pro_detail_modal_pointer">
                                  <h2>{item?.ProductName} </h2>
                                  <p>{item?.ProductDescription}</p>
                                  {item?.IsProductInOffer == false ? (
                                    <h3>
                                      Deal Price<span>₹ {item?.DealPrice}</span>
                                    </h3>
                                  ) : null}
                                  <h3>
                                    MRP<span>₹ {item?.Mrp}</span>
                                  </h3>
                                  {timeDifferenceInHours > 24 ? (
                                    <h3>
                                      <strong>
                                        Till:{" "}
                                        {moment(item?.ToPushlishDate).format(
                                          "LL"
                                        )}
                                      </strong>
                                    </h3>
                                  ) : (
                                    <ProductCountdown
                                      item={item}
                                      val="tillTime"
                                    />
                                  )}
                                </div>
                                <div className="mb-0">
                                  <input
                                    type="button"
                                    onClick={() => {
                                      router(
                                        `/productdetail/${Encryption(item?.Id)}`
                                      );
                                    }}
                                    value={
                                      item?.IsProductInOffer == true
                                        ? "Bid Now"
                                        : item?.IsProductInOffer == false
                                        ? "Buy Now"
                                        : item?.IsProductInOffer == null
                                        ? "Contact Us"
                                        : null
                                    }
                                    className={
                                      item?.IsProductInOffer == true
                                        ? "common_btn_new bid_now_btn_01"
                                        : item?.IsProductInOffer == false
                                        ? "common_btn_new"
                                        : item?.IsProductInOffer == null
                                        ? "common_btn_new"
                                        : null
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default VendorProductsDetailComponent;
